/*
 *   File : chip.js
 *   Author : https://evoqins.com
 *   Description : chip component
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React from "react";

export default function Chip({ style, labelStyle, textClr, text }) {
  return (
    <div className={`${style ? style : "px-2 py-1"} rounded-pill`}>
      <p
        className={`${
          labelStyle ? labelStyle : "fw-400 fs-10 lh-12"
        } ${textClr} mb-0`}
      >
        {text}
      </p>
    </div>
  );
}
